// regex source - https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions/Unicode_Property_Escapes#examples
export const omitEmojisFromText = (text?: null | string): string => {
  if (!text) {
    return '';
  }

  return text.replaceAll(/\p{Extended_Pictographic}/gu, '');
};
